const configProd = {
  firebase: {
    apiKey: 'AIzaSyCLSoq4O2HPhvp4brVoF1iCcpL6uaaXRSI',
    appId: '1:755200641676:web:5a908b9f5401f0eb2989a9',
    authDomain: 'testevocacionalunilasalle.firebaseapp.com',
    databaseURL: 'https://testevocacionalunilasalle.firebaseio.com',
    measurementId: 'G-GHTD8CN77P',
    messagingSenderId: '755200641676',
    projectId: 'testevocacionalunilasalle',
    storageBucket: 'testevocacionalunilasalle.appspot.com'
  }
};

export default configProd;
